import {DLMSiteApplicationsListToolbar} from './DLMSiteApplicationsListToolbar'
import {DLMSiteApplicationsListSearchComponent} from './DLMSiteApplicationsListSearchComponent'

const DLMSiteApplicationsListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
        <DLMSiteApplicationsListSearchComponent />        
        <div className='card-toolbar'>        
            <DLMSiteApplicationsListToolbar />        
        </div>      
    </div>
  )
}

export {DLMSiteApplicationsListHeader}
